import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import { getContact, openContact } from '../../pages/WelcomePage/helpers/cardsSupport';

const SupportCard = ({ contact }) => {
  const { t } = useTranslation();

  const { type, text, title, icon, name } = contact;

  return (
    <div className="support-card-wrapper" onClick={() => openContact(getContact(type))}>
      <div className="support-card-text-wrapper">
        {text && <p className="support-card-text">{t(text)}</p>}
        <h2 className="support-card-title">{t(title)}</h2>
      </div>
      <img className="support-card-icon" src={icon} alt={name} />
    </div>
  );
};

export default SupportCard;
